import gql from 'graphql-tag';

export const requestCloudinaryUploadSignatureMutation = gql`
  mutation RequestCloudinaryUploadSignature {
    requestCloudinaryUploadSignature {
      signature
      timestamp
      public_id
    }
  }
`;